import classNames from 'classnames';

import './style.scss';
import { IntlKey } from 'locales';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

export type TextInputLabelledProps = {
  label: string;
  value: Nullable<string>;
  onValueChanged: (value: Nullable<string>) => void;
  id?: string;
  type?: 'text' | 'password' | 'email';
  isReadOnly?: boolean;
  placeholder?: string;
  className?: string;
  isInvalid?: boolean;
  isHighlighted?: boolean;
};

export function TextInputLabelled({
  label,
  value,
  onValueChanged,
  id,
  type = 'text',
  isReadOnly = false,
  isInvalid = false,
  isHighlighted = false,
  placeholder = '',
  className,
}: TextInputLabelledProps) {
  const { formatMessage } = useIntl();
  const [internalValue, setInternalValue] = useState<Nullable<string>>(value);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const handleOnBlur = (val: string | undefined) => {
    const newValue: Nullable<string> = val !== undefined ? val : null;
    onValueChanged(newValue);
  };

  const handleOnChange = (val: string) => {
    setInternalValue(val);
  };

  const translatedValue = formatMessage({
    id: `field.${internalValue}` as IntlKey,
    defaultMessage: `${internalValue}`,
  });

  return (
    <div className="text-input-container input-group bg-lvl1">
      <div className="label input-icon-start w-auto px-12px">
        <label htmlFor={id} className="text-secondary">
          {label}
        </label>
      </div>
      <input
        id={id}
        name={id}
        type={type}
        value={translatedValue}
        onBlur={e => handleOnBlur(e.target.value)}
        onChange={e => handleOnChange(e.target.value)}
        readOnly={isReadOnly}
        placeholder={placeholder}
        className={classNames(`input form-control form-control-lg ps-3 fs-2 fw-medium w-100 ${className}`, {
          'is-warning': isInvalid,
          'border-bottom border-info': isHighlighted,
        })}
      />
    </div>
  );
}
